export const ItemInlineComponent = {
  bindings: {
    title: '@',
  },
  transclude: true,
  templateUrl: 'components/Items/item-inline/item-inline.html',
};
